import {ChangeDetectorRef, Component, Inject, OnInit, ViewChild, DOCUMENT} from '@angular/core';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';
import {UntypedFormGroup} from '@angular/forms';
import {MatTableDataSource} from '@angular/material/table';
import {TopicIndex} from '@shared/models/topic-index.model';
import {TranslationService} from '@shared/services/translation.service';
import {SchoolingOnlineService} from '@shared/services/schooling-online.service';
import {TopicBookletService} from '@shared/services/topic-booklet.service';
import {TopicIndexService} from '@shared/services/topic-index.service';
import {ActivatedRoute, Router} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';

import {DEFAULT_PAGE_SIZE, PAGE_SIZE_OPTIONS, pageChange} from '@shared/utils/utils';
import {tap} from 'rxjs/operators';
import {any} from 'codelyzer/util/function';

@Component({
    selector: 'saf-schooling-booklet-content',
    templateUrl: './schooling-booklet-content.component.html',
    styleUrls: ['./schooling-booklet-content.component.scss'],
    standalone: false
})
export class SchoolingBookletContentComponent implements OnInit {
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  public bookletId: number;
  public lastIndexId: number;
  public tableColumns = ['number', 'title', 'type'];
  public dataSource = new MatTableDataSource<TopicIndex>();
  public drawerFilterParams: any = {};
  public searchFilterParams: any = {};
  public loading = false;
  public totalCount = 0;
  public pageNumber: number;
  public lastPage: number;
  public indexContentData: any;
  public tuitionId: number = null;
  fold = false;
  public trackById = (item) => item.id;

  constructor(
    private translationService: TranslationService,
    private schoolingOnlineService: SchoolingOnlineService,
    private topicBookletService: TopicBookletService,
    private changeDetectorRef: ChangeDetectorRef,
    private indexService: TopicIndexService,
    private route: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PAGE_SIZE_OPTIONS) public pageSizeOptions,
    @Inject(DEFAULT_PAGE_SIZE) public pageSize,
  ) { }

  ngOnInit(): void {
    this.bookletId = +this.route.snapshot.paramMap.get('id');
    this.tuitionId = +this.route.snapshot.queryParamMap.get('tuitionId') || null;
    // this.route.queryParams.subscribe(params => {
    //   this.bookletId = params;
    // });
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
    // merge(this.sort.sortChange, this.paginator.page).subscribe(() => this.loadTable());
  }

  ngAfterViewInit() {
    this.loadTable();
    this.changeDetectorRef.detectChanges();
  }

  loadTable() {
    const params = {
      filter: {
        ...this.searchFilterParams,
        ...this.drawerFilterParams,
        bookletId: this.bookletId,
        active: true
      },
      sort: this.sort.direction ? this.sort.active : '',
      dir: this.sort.direction,
      start: this.paginator.pageIndex * this.paginator.pageSize,
      limit: this.paginator.pageSize,
    };

    this.loading = true;

    this.indexService.getList(params)
      .pipe(tap(() => this.loading = false))
      .subscribe((result) => {
        result.data.forEach((item, x, array) => {
          this.lastPage = array.length;
          if (item.pageNumber === 1) {
            this.lastIndexId = item.id;
            this.pageNumber = item.pageNumber;
          }
        });
        this.totalCount = result.total;
        this.dataSource.data = result.data;
      });
  }

  reloadTable() {
    TopicIndexService.clearCache();
    this.loadTable();
  }

  getTypeDescription(pageType: number) {
    switch (pageType) {
      case 1: return this.translationService.translate('questionary');
      case 2: return this.translationService.translate('video');
      default: return this.translationService.translate('page');
    }
  }

  getTypeIcon(pageType: number) {
    switch (pageType) {
      case 1: return 'quiz';
      case 2: return 'video_file';
      default: return 'description';
    }
  }

  showPreview(e, item: any) {
    this.lastIndexId = item.id;
    this.pageNumber = item.pageNumber;
    this.getContent();
  }

  getContent() {
    this.indexService.getContent(this.lastIndexId)
      .subscribe((data: any) => {
        this.indexContentData = data;
      });
  }

  next() {
    this.pageNumber = this.pageNumber + 1;
    this.dataSource.data.forEach(item => {
      if (item.pageNumber === this.pageNumber) {
        this.pageNumber = item.pageNumber;
        this.lastIndexId = item.id;
      }
    });
    this.getContent();
  }

  foldTable() {
    this.fold = !this.fold;
  }

  back() {
    this.pageNumber = this.pageNumber - 1;
    this.dataSource.data.forEach(item => {
      if (item.pageNumber === this.pageNumber) {
        this.pageNumber = item.pageNumber;
        this.lastIndexId = item.id;
      }
    });
    this.getContent();
  }

  ready() {
    this.router.navigate(['schooling/' + this.tuitionId]);
  }

    protected readonly pageChange = pageChange;
}
